// extracted by mini-css-extract-plugin
export var modal = "ModalWrapper-module--modal--eDY4C";
export var overlay = "ModalWrapper-module--overlay--757eu";